export default "__VITE_ASSET__RFHrctlP__"